import { Routes } from '@angular/router';

import { WorkOrderPortal } from './pages/work-order-portal/work-order-portal';

export const routes: Routes = [
  { path: '', component: WorkOrderPortal },
];
